import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ManualPreadviceEditSimpleDialog from './ManualPreadviceEditSimpleDialog';

class ManualPreadviceTransactionsEdit extends Component {
  render() {
    return (
      <div>
        <ManualPreadviceEditSimpleDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

ManualPreadviceTransactionsEdit.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default ManualPreadviceTransactionsEdit;
